document.addEventListener('DOMContentLoaded', () => {
  const buttonAddToCart = document.querySelector('.quantity-addToCart-block-wrapper');
  const addToCartBox = document.querySelector('.product__price-addToCart-wrapper');
  if (window.innerWidth < 768) {
    buttonAddToCart.classList.add('sticky');
    window.addEventListener('scroll', () => {
      const addToCartRect = addToCartBox.getBoundingClientRect();
      if (addToCartRect.top <= window.innerHeight && addToCartRect.bottom >= 0) {
        buttonAddToCart.classList.remove('sticky');
      } else {
        buttonAddToCart.classList.add('sticky');
      }
    });
  }
});
